/* @flow */

import Request from './request'
import Response from './response'
import Headers from './headers'
import { support, responseURL } from './helpers'
import ProgressPromise from './progress_promise'

export const headers = (xhr: XMLHttpRequest) => {
  const head = new Headers({})
  const pairs = xhr
    .getAllResponseHeaders()
    .trim()
    .split('\n')
  pairs.forEach((header) => {
    const split = header.trim().split(':')
    const key = split.shift().trim()
    const value = split.join(':').trim()
    head.append(key, value)
  })
  return head
}

export const onload = (xhr: XMLHttpRequest, resolve: any, reject: any) => () => {
  if (xhr.readyState !== 4) {
    return
  }
  const status = xhr.status === 1223 ? 204 : xhr.status
  if (status < 100 || status > 599) {
    reject(new TypeError('Network request failed'))
    return
  }
  const options = {
    status: status,
    statusText: xhr.statusText,
    headers: headers(xhr),
    url: responseURL(xhr)
  }
  const body = 'response' in xhr ? xhr.response : xhr.responseText
  resolve(new Response(body, options))
}

const fetch = (input: Request | string, init: ?Object) => {
  let request: Request
  if (input instanceof Request && init !== undefined) {
    request = input
  } else if (typeof input === 'string') {
    request = new Request(input, init)
  }

  const promise = new ProgressPromise((resolve, reject, onCancel, onProgress) => {
    const xhr = new XMLHttpRequest()

    if (request.credentials == 'include') {
      xhr.withCredentials = true
    }

    xhr.onreadystatechange = onload(xhr, resolve, reject)
    xhr.onload = onload(xhr, resolve, reject)
    xhr.onerror = () => {
      reject(new TypeError('Network request failed'))
    }
    xhr.upload.onprogress = onProgress

    xhr.open(request.method, request.url, true)

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach((name, values) => {
      values.forEach((value) => {
        xhr.setRequestHeader(name, value)
      })
    })

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)

    onCancel(() => {
      xhr.abort()
    })
  })
  return promise
}

export default fetch
